<template>
  <div id="index">
    <div class="row expanded">
      <div class="small-12 medium-offset-1 medium-10 columns hero-container">
        <div class="hero">
          <h1 class="hero__header" v-html="page.acf.claim">Partner w inwestycjach<br>deweloperskich</h1>
        </div>
      </div>
    </div>
    <div class="row section-whitespace">
      <div class="small-12 medium-offset-2 medium-4 columns">
        <h2 class="big-header" v-html="page.title.rendered"></h2>
      </div>
      <div class="small-10 small-offset-2 medium-offset-6 medium-6 large-5 columns" v-html="page.content.rendered">
        <router-link title="Link do podstrony dlaczego?" class="btn margin-tp-2" :to="{ path: '/dlaczego' }">Dlaczego z Gainvest?</router-link>
      </div>
    </div>
    <div class="row section-whitespace">
      <div class="small-10 small-offset-2 medium-offset-1 medium-11 columns">
        <slick class="gold-slider" ref="slick" :options="slickOptions">
          <div v-for="(item, index) in items" :key="index" class="gold-slide" v-if="item._embedded">
            <a target="_blank" :href="item._embedded['wp:featuredmedia'][0].media_details.sizes['full'].source_url">
              <div v-html="item.content.rendered"></div>
              <p class="text-right">
                {{ item.title.rendered }}
              </p>
            </a>
          </div>
        </slick>
      </div>
    </div>
  </div>
</template>

<script>
import Slick from 'vue-slick'

export default {
  props: ['responsiveItems'],
  data () {
    return {
      page: {
        title: {
          rendered: ''
        },
        content: {
          rendered: ''
        },
        acf: {
          claim: ''
        }
      },
      items: [],
      slickOptions: {
        slidesToShow: 1,
        arrows: true,
        infinite: false,
        dots: false,
        mobileFirst: true,
        nextArrow: '<button type="button" class="slider__arrow slider__arrow--next"><img src="/static/icons/arrow.svg"></button>',
        prevArrow: '<button type="button" class="slider__arrow slider__arrow--prev"><img src="/static/icons/arrow.svg"></button>',
        responsive: [
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      }
    }
  },
  components: {
    Slick
  },
  beforeCreate: function () {
    this.$http.get(`wp/v2/references?per_page=3&_embed`).then(response => {
      for (let post in response.data) {
        this.items.push(response.data[post])
      }
    }, error => { console.log(error) })

    this.$http.get(`wp/v2/pages/126`).then(response => {
      if (typeof window !== 'undefined') {
        this.page = response.data
      }
    }, error => { console.log(error) })
  },
  beforeUpdate () {
    this.$refs.slick.destroy()
  },
  updated () {
    this.$refs.slick.create()
  }
}
</script>

<style lang="sass">
  @import '../../node_modules/slick-carousel/slick/slick.css';
</style>



// WEBPACK FOOTER //
// src/components/Index.vue